import {
  ApiSlugs,
  UpdateUserEmailNotificationsDto,
  UserDto,
  UserEmailNotificationsDto,
  UserId,
} from '@workspace/data-types';
import { Observable } from 'rxjs';
import { ApiCaller } from '../../../../../api-caller.service';
import { ApiConnector } from '../../../../../api-connector.abstract-service';

export class UserNotificationsConnector extends ApiConnector<UserDto, UserDto, UserId> {
  constructor(apiCaller: ApiCaller, slug: string, apiPrefix: string) {
    super(apiCaller, apiPrefix, `${slug}/${ApiSlugs.NOTIFICATIONS}`);
  }

  updateEmailNotifications(dto: UpdateUserEmailNotificationsDto): Observable<UserEmailNotificationsDto> {
    return this.apiCaller.patchRequest(this.apiPrefix, `${this.slug}/email`, dto);
  }
}
